'use client';

import { FC } from 'react';
import { RecommendationBlockStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { Container } from 'atoms/Container';
import { Body, Title } from 'atoms/Typography/Typography';
import styles from './styles.module.css';

export const RecommendationBlockBody: FC<{
  blok: RecommendationBlockStoryblok;
}> = ({ blok }) => (
  <Container className={styles.root}>
    <div className={styles.recommendations}>
      <Title type="md" className={styles.subtitle}>
        {blok.subtitle}
      </Title>
      {blok?.link ? (
        <Button color="purple" href={blok.link} className={styles.button}>
          {blok.title}
        </Button>
      ) : (
        <Body type="md" weight="bold" className={styles.title}>
          {' '}
          {blok.title}
        </Body>
      )}
    </div>
  </Container>
);
